var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'cursocisco'}}},[_c('v-card',{staticClass:"mx-auto mt-4 mb-4",attrs:{"max-width":"344"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }